<template>
  <layout-breadcrumb-cartao
    @limpar-filtro="limparFiltro"
    filtroAplicado="Nenhum filtro aplicado."
    :semFiltro="false"
    :arrTexto="arrTexto"
    titulo="Dashboard"
    :breadcrumb="bread"
    icone="pie-chart"
  >
    <ContainerDashboard @mudar-lista-filtro="mudarListaFiltro" />
  </layout-breadcrumb-cartao>
</template>

<script>
/* eslint-disable */
import ContainerDashboard from "./shared/componentes/ContainerDashboard";

export default {
  components: {
    ContainerDashboard
  },
  data() {
    return {
      callbackLimpar: null,
      arrTexto: [],
      bread: [{ titulo: "Início", url: "/home" }, { titulo: "Dashboard" }]
    };
  },
  methods: {
    /**
     * @param { { arr: Array<Object>, callback: Function } } objetoMudar - objeto padrão para a
     * mudança na listagem de filtros
     */
    mudarListaFiltro(objetoMudar) {
      const { arr, callback } = objetoMudar;

      this.arrTexto = arr;
      this.callbackLimpar = callback;
    },
    limparFiltro() {
      if (this.callbackLimpar === null) return;

      this.callbackLimpar();
      this.arrTexto = [];
      this.callbackLimpar = null;
    }
  }
};
</script>